import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'

const initialState={
    orderList:[],
    orderSummaryList:[],
    selectedOrder: null,
    selectedOrderSummary: null,
    status:"idle",
    registerstatus:'failure',
    editstatus:'failure',
    deletestatus:'failure',
    error:''
}


export const fetchOrders=createAsyncThunk('orders/fetchOrders', async ()=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        '/baskets/orders/getOrders',
        {
            headers: {
                'Authorization': `Basic ${auth}`,
                'Accept': 'application/json'
            }
        }
    )
    return response.json()
})

export const fetchOrderSummary=createAsyncThunk('orders/fetchOrderSummary', async ()=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        '/baskets/orders/getOrderSummary',
        {
            headers: {
                'Authorization': `Basic ${auth}`,
                'Accept': 'application/json'
            }
        }
    )
    return response.json()
})

export const createOrder = createAsyncThunk('orders/createOrder', async (orderData)=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        '/baskets/orders/create',
        {
            method: 'POST',
            headers: {
                'Authorization': `Basic ${auth}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(orderData)
        }
    )
    return response.json();
})

export const fetchOrderById=createAsyncThunk('orders/fetchOrderById', async (orderId)=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        `/baskets/orders/getOrderById/${orderId}`,
        {
            headers: {
                'Authorization': `Basic ${auth}`,
                'Accept': 'application/json'
            }
        }
    )
    return response.json()
})

export const fetchOrderSummaryById=createAsyncThunk('orders/fetchOrderSummaryById', async (orderId)=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        `/baskets/orders/getOrderSummaryById/${orderId}`,
        {
            headers: {
                'Authorization': `Basic ${auth}`,
                'Accept': 'application/json'
            }
        }
    )
    return response.json()
})

export const createVoidOrder = createAsyncThunk('orders/createVoidOrder', async (orderData)=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        '/baskets/orders/createVoidOrder',
        {
            method: 'POST',
            headers: {
                'Authorization': `Basic ${auth}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(orderData)
        }
    )
    return response.json();
})


export const asseebleOrder = createAsyncThunk('orders/asseeblableOrder', async (orderData)=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        '/baskets/orders/assebleOrderp',
        {
            method: 'POST',
            headers: {
                'Authorization': `Basic ${auth}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(orderData)
        }
    )
    return response.json();
})


const orderSlice=createSlice({
    name:"orders",
    initialState,
    reducers:{
        changeRegisterStatus:(state)=>{
            state.registerstatus='failure';
        },
        changeEditStatus:(state)=>{
            state.editstatus='failure';
        }
    },
    extraReducers:(builder)=>{
        builder
            .addCase(fetchOrders.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchOrders.fulfilled, (state, action) => {
                state.status = 'success';
                state.orderList = action.payload;
            })
            .addCase(fetchOrders.rejected, (state, action) => {
                state.status = 'error';
                state.error = state.error.message || 'Failed to fetch orders';
            })
            .addCase(fetchOrderSummary.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchOrderSummary.fulfilled, (state, action) => {
                state.status = 'success';
                state.orderSummaryList = action.payload;
            })
            .addCase(fetchOrderSummary.rejected, (state, action) => {
                state.status = 'error';
                state.error = state.error.message || 'Failed to fetch order summary';
            })
            .addCase(createOrder.pending, (state) => {
                state.registerstatus = 'loading';
            })
            .addCase(createOrder.fulfilled, (state, action) => {
                state.registerstatus = 'success';
                state.orderList.push(action.payload);
            })
            .addCase(createOrder.rejected, (state, action) => {
                state.registerstatus = 'failure';
                state.error = action.error.message || 'Failed to create order';
            })
            .addCase(fetchOrderById.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchOrderById.fulfilled, (state, action) => {
                state.status = 'success';
                state.selectedOrder = action.payload;
            })
            .addCase(fetchOrderSummaryById.rejected, (state, action) => {
                state.status = 'error';
                state.error = action.error.message || 'Failed to fetch order by ID';
            })
            .addCase(fetchOrderSummaryById.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchOrderSummaryById.fulfilled, (state, action) => {
                state.status = 'success';
                state.selectedOrderSummary = action.payload;
            })
            .addCase(fetchOrderById.rejected, (state, action) => {
                state.status = 'error';
                state.error = action.error.message || 'Failed to fetch order by ID';
            })
            .addCase(createVoidOrder.pending, (state) => {
                state.registerstatus = 'loading';
            })
            .addCase(createVoidOrder.fulfilled, (state, action) => {
                state.registerstatus = 'success';
                state.orderList.push(action.payload);
            })
            .addCase(createVoidOrder.rejected, (state, action) => {
                state.registerstatus = 'failure';
                state.error = action.error.message || 'Failed to create void order';
            })
            .addCase(asseebleOrder.pending, (state) => {
                state.registerstatus = 'loading';
            })
            .addCase(asseebleOrder.fulfilled, (state, action) => {
                state.registerstatus = 'success';
                // Update the order in the orderList with the assembled order details
                const index = state.orderList.findIndex(order => order.id === action.payload.id);
                if (index !== -1) {
                    state.orderList[index] = action.payload;
                }
            })
            .addCase(asseebleOrder.rejected, (state, action) => {
                state.registerstatus = 'failure';
                state.error = action.error.message || 'Failed to assemble order';
            });
    }
})

export default orderSlice.reducer;

